// eslint-disable-next-line no-redeclare,no-unused-vars
function addTillhubPartialSendButton(cont, param, key, context) {
    const object = context.object;
    const row = context.row;
    if (key !== 'tillhubPayment') return;
    if (!cont) return;
    setTimeout(function() {
        const field3Button = cont.find('button').filter(function() {
            const text = $(this).text().toLowerCase();
            return text.includes('teilbetrag') || text.includes('teilzahlung');
        });
        if (field3Button.length > 0) field3Button.off('click').on('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            const fields = [
                {
                    key: 'amount',
                    label: 'Betrag',
                    field: 'decimal',
                    required: true,
                    placeholder: '0.00'
                }
            ];
            buildPromptPopup(fields, function(amount) {
                if (!amount) {
                    showInfo('Bitte Betrag eingeben', 'error');
                    return false;
                }
                if (parseFloat(amount) <= 0) {
                    showInfo("Betrag muss gr\xf6\xdfer als 0 sein", 'error');
                    return false;
                }
                loading(true);
                ajax({
                    object: object,
                    id: row.id,
                    send: {
                        func: 'getTillhubPartialPaymentLaravelApi',
                        endpoint: 'tillhub/order/' + row.id + '/send-partial',
                        amount: amount
                    },
                    background: true,
                    noSuccessInfo: true,
                    callback: function(xhr) {
                        if (xhr.laravelApiUrl) $.ajax({
                            url: xhr.laravelApiUrl,
                            method: 'POST',
                            contentType: 'application/json',
                            data: JSON.stringify({
                                amount: parseFloat(amount)
                            }),
                            headers: {
                                'X-Requested-With': 'XMLHttpRequest',
                                'Content-Type': 'application/json'
                            },
                            success: function(response) {
                                loading(false);
                                if (response && response.error) showInfo(response.error, 'error');
                                else if (response && response.success) showInfo('Betrag erfolgreich gesendet', 'success');
                                else showInfo('Fehler beim Senden des Betrags', 'error');
                            },
                            error: function(xhr) {
                                loading(false);
                                var errorMsg = 'Fehler beim Senden des Betrags';
                                if (xhr.responseJSON && xhr.responseJSON.error) errorMsg = xhr.responseJSON.error;
                                else if (xhr.responseText) try {
                                    var response = JSON.parse(xhr.responseText);
                                    if (response.error) errorMsg = response.error;
                                } catch (e) {
                                    errorMsg = xhr.responseText || errorMsg;
                                }
                                showInfo(errorMsg, 'error');
                            }
                        });
                        else {
                            loading(false);
                            showInfo('Fehler beim Generieren der API URL', 'error');
                        }
                    }
                });
            }, {
                title: 'Betrag senden',
                titleSave: "\xdcbernehmen"
            });
        });
    }, 100);
}

//# sourceMappingURL=index.2b50f1d8.js.map
